import { takeLatest, put, call } from 'redux-saga/effects';
import { GET_CHATBOT_RESPONSE_REQUEST } from '../../../../actionTypes';
import { getChatbotResponseSuccess, getChatbotResponseFailure } from '../../../../actions/chatbot';
import getChatbotResponse from '../../../apiCalls/chatbot/getChatbotResponse';

function* getResponse(action) {
  try {
    const response = yield call(getChatbotResponse, action.payload);
    if (response.error) {
      yield put(getChatbotResponseFailure(response));
    } else {
      yield put(getChatbotResponseSuccess(response));
    }
  } catch (error) {
    yield put(getChatbotResponseFailure(error));
  }
}

function* root() {
  yield takeLatest(GET_CHATBOT_RESPONSE_REQUEST, getResponse);
}

export default root;
